<div class="fritz-font scroll h-screen w-full overflow-y-auto text-white">
  <div class="bg-header relative z-30">
    <div class="p2 flex flex-col gap-4 lg:p-8">
      <div class="hidden w-full justify-between gap-8 lg:flex">
        <a [href]="homeBaseUrl()"
          ><img class="my-8 h-[80px] w-[320px] cursor-pointer" src="../../../assets/img/trading.svg" (click)="onHome()"
        /></a>
        <app-select-item
          class="xl:ml-24"
          [width]="800"
          [height]="160"
          [offsetY]="-48"
          (selectItem)="onSelectItem($event)"
        ></app-select-item>
        <div class="my-2 flex w-[480px] gap-4">
          <div class="bg-gradient my-4 h-24 w-24 rounded-full border-2 border-gwt-brown shadow-xl">
            <img class="h-full w-full py-3 pl-3" [src]="getImageSource(item)" />
          </div>
          <div class="text-shadow flex w-[360px] flex-col">
            <div class="mb-2 text-xl">{{ item?.name || 'loading' }}</div>
            <div class="text-no-overflow text-sm" [title]="detail" *ngFor="let detail of details">{{ detail }}</div>
          </div>
        </div>
      </div>
      <div class="flex w-full flex-col justify-between gap-2 lg:hidden">
        <app-select-item
          class="full"
          [width]="800"
          [height]="160"
          [offsetY]="-48"
          (selectItem)="onSelectItem($event)"
        ></app-select-item>
        <div class="-mt-8 flex w-full justify-between p-2">
          <a [href]="homeBaseUrl()"
            ><img
              class="my-4 h-10 w-40 cursor-pointer md:my-8 md:h-[80px] md:w-[320px]"
              src="../../../assets/img/trading.svg"
              (click)="onHome()"
          /></a>
          <div class="my-2 flex w-60 gap-2 md:w-[480px] md:gap-4">
            <div
              class="bg-gradient my-2 h-12 w-12 rounded-full border-2 border-gwt-brown shadow-xl md:my-4 md:h-24 md:w-24"
            >
              <img class="h-full w-full object-contain py-1.5 pl-1.5 md:py-3 md:pl-3" [src]="getImageSource(item)" />
            </div>
            <div class="text-shadow flex w-44 flex-col md:w-[360px]">
              <div class="mb-2 text-base md:text-xl">{{ item?.name || 'loading' }}</div>
              <div class="text-no-overflow text-xs md:text-sm" [title]="detail" *ngFor="let detail of details">
                {{ detail }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="h-12 w-full"></div>
  </div>
  <div
    class="bg-theme bg-base section-transition relative z-20 -mt-24 h-fit pb-32 pt-16 md:h-full md:min-h-screen md:pb-0"
  >
    <!-- <div class="mx-auto w-[1000px]">
      <div class="mt-8 text-2xl text-shadow">Item details</div>
      <div class="mt-8 text-lg text-shadow">
        <pre>{{ displayRawItem() }}</pre>
      </div>
    </div> -->
    <div class="mt-8 flex h-full w-full flex-col md:flex-row">
      <div class="mx-auto flex h-full flex-col px-16">
        <div class="p-2 text-center text-2xl">Sell Orders</div>
        <div class="flex h-fit w-full flex-col justify-center gap-4 md:max-h-full md:flex-row">
          <div
            class="frame flex max-h-[calc(100vh_-_250px)] flex-col overflow-y-auto p-2"
            *ngFor="let itemPriceLists of allOrders.sellOrders; let sl = index"
          >
            <div class="flex flex-col gap-2 p-2" *ngFor="let itemTimeList of itemPriceLists.orders; let so = index">
              <div class="text-center text-sm underline">{{ timeToString(itemTimeList.time) }}</div>
              <div
                class="frame flex w-80 flex-col p-2"
                [ngClass]="getOldOpacity(order)"
                *ngFor="let order of itemTimeList.orders; let so = index"
              >
                <div class="flex gap-1">
                  <div class="flex flex-col gap-1">
                    <img class="h-12 w-12 object-contain" [src]="getImageSource(item)" />
                  </div>
                  <div class="bg-slash relative -ml-2 flex h-12 w-12">
                    <div class="absolute -left-1 top-0 w-8 text-center text-sm">{{ order.div_quantity }}</div>
                    <div class="absolute -right-1 bottom-0 w-8 text-center text-sm">{{ order.div_price }}</div>
                  </div>
                  <!-- <div class="flex flex-col w-12 h-12 -ml-2">
                  <div class="flex justify-start w-full h-3 gap-1" *ngIf="order.div_quantity !== order.quantity">
                    <div class="text-xs">{{ order.div_quantity }}</div>
                    <i class="self-center h-3 text-xs text-white fa fa-arrow-right"></i>
                  </div>
                  <div class="flex justify-end w-full h-3 gap-1" *ngIf="order.div_quantity !== order.quantity">
                    <i class="self-center h-3 text-xs text-white fa fa-arrow-left"></i>
                    <div class="text-xs">{{ order.div_price }}</div>
                  </div>
                  <div class="flex justify-start w-full h-3 gap-1">
                    <div class="text-xs">{{ order.quantity }}</div>
                    <i class="self-center h-3 text-xs text-white fa fa-arrow-right"></i>
                  </div>
                  <div class="flex justify-end w-full h-3 gap-1">
                    <i class="self-center h-3 text-xs text-white fa fa-arrow-left"></i>
                    <div class="text-xs">{{ order.price.price }}</div>
                  </div>
                </div> -->
                  <div class="flex flex-col gap-1">
                    <img class="h-12 w-12 object-contain p-1" [src]="getCurrencySource(order.price.type)" />
                  </div>
                  <div class="flex w-[154px] flex-col gap-1">
                    <div class="ml-1 flex justify-between gap-2">
                      <!-- <div class="text-sm">stock: {{ order.quantity }}</div> -->
                      <div class="-mt-1 flex flex-col">
                        <div class="flex gap-1">
                          <div class="text-xs">max:</div>
                          <div class="text-xs">{{ order.quantity }}</div>
                          <img class="h-4 w-4 object-contain" [src]="getImageSource(item)" />
                        </div>
                        <div class="-mb-1 flex gap-1">
                          <div class="text-xs">for:</div>
                          <div class="text-xs">{{ order.price.price }}</div>
                          <img class="h-4 w-4 object-contain" [src]="getCurrencySource(order.price.type)" />
                        </div>
                      </div>
                      <div class="bg-button action p-1 text-xs" (click)="whisper(order)">Whisper</div>
                    </div>
                    <div class="flex justify-end" [title]="order.player">
                      <div class="text-no-overflow text-right">{{ order.player }}</div>
                      <div class="relative h-6 w-6" *ngIf="order.daybreakOnline">
                        <img
                          class="absolute left-1 top-0.5 h-6 w-6"
                          src="../../../assets/img/online.png"
                          title="Player online with Daybreak"
                        />
                      </div>
                      <div class="relative h-6 w-6" *ngIf="order.authCertified">
                        <img
                          class="absolute left-1 top-0.5 h-6 w-6"
                          src="../../../assets/img/certified.png"
                          title="Player name certified"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <app-item-details class="-mt-1 mb-1" [item]="order.item" [details]="order.details"></app-item-details>
                <div class="relative flex min-h-4 pr-12 text-xs">
                  <span class="px-1">{{ order.description }}</span>
                  <div class="absolute bottom-0 right-0 -mb-1 mt-1 flex">
                    <span>{{ formatLastUpdate(order.lastRefresh) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mx-auto flex h-full flex-col px-16">
        <div class="p-2 text-center text-2xl">Buy Orders</div>
        <div class="flex w-full flex-col justify-center gap-4 md:max-h-full md:flex-row">
          <div
            class="frame flex max-h-[calc(100vh_-_250px)] flex-col p-2"
            *ngFor="let itemPriceLists of allOrders.buyOrders; let sl = index"
          >
            <div class="flex flex-col gap-2 p-2" *ngFor="let itemTimeList of itemPriceLists.orders; let so = index">
              <div class="text-center text-sm underline">{{ timeToString(itemTimeList.time) }}</div>
              <div class="frame flex w-80 flex-col p-2" *ngFor="let order of itemTimeList.orders; let so = index">
                <div class="flex gap-1">
                  <div class="flex flex-col gap-1">
                    <img class="h-12 w-12 object-contain p-1" [src]="getCurrencySource(order.price.type)" />
                  </div>

                  <div class="bg-slash relative -ml-2 flex h-12 w-12">
                    <div class="absolute -left-1 top-0 w-8 text-center text-sm">{{ order.div_price }}</div>
                    <div class="absolute -right-1 bottom-0 w-8 text-center text-sm">{{ order.div_quantity }}</div>
                  </div>
                  <!-- <div class="flex flex-col w-12 h-12 -ml-2">
                  <div class="flex justify-start w-full h-3 gap-1" *ngIf="order.div_quantity !== order.quantity">
                    <div class="text-xs">{{ order.div_price }}</div>
                    <i class="self-center h-3 text-xs text-white fa fa-arrow-right"></i>
                  </div>
                  <div class="flex justify-end w-full h-3 gap-1" *ngIf="order.div_quantity !== order.quantity">
                    <i class="self-center h-3 text-xs text-white fa fa-arrow-left"></i>
                    <div class="text-xs">{{ order.div_quantity }}</div>
                  </div>
                  <div class="flex justify-start w-full h-3 gap-1">
                    <div class="text-xs">{{ order.price.price }}</div>
                    <i class="self-center h-3 text-xs text-white fa fa-arrow-right"></i>
                  </div>
                  <div class="flex justify-end w-full h-3 gap-1">
                    <i class="self-center h-3 text-xs text-white fa fa-arrow-left"></i>
                    <div class="text-xs">{{ order.quantity }}</div>
                  </div>
                </div> -->
                  <div class="flex flex-col gap-1">
                    <img class="h-12 w-12 object-contain" [src]="getImageSource(item)" />
                  </div>
                  <div class="flex w-[154px] flex-col gap-1">
                    <div class="ml-1 flex justify-between gap-2">
                      <div class="-mt-1 flex flex-col">
                        <div class="flex gap-1">
                          <div class="text-xs">max:</div>
                          <div class="text-xs">{{ order.price.price }}</div>
                          <img class="h-3 w-3 object-contain" [src]="getCurrencySource(order.price.type)" />
                        </div>
                        <div class="-mb-1 flex gap-1">
                          <div class="text-xs">for:</div>
                          <div class="text-xs">{{ order.quantity }}</div>
                          <img class="h-4 w-4 object-contain" [src]="getImageSource(item)" />
                        </div>
                      </div>
                      <div class="bg-button action p-1 text-xs" (click)="whisper(order)">Whisper</div>
                    </div>
                    <div class="flex justify-end" [title]="order.player">
                      <div class="text-no-overflow text-right">{{ order.player }}</div>
                      <div class="relative h-6 w-6" *ngIf="order.daybreakOnline">
                        <img
                          class="absolute left-1 top-0.5 h-6 w-6"
                          src="../../../assets/img/online.png"
                          title="Player online with Daybreak"
                        />
                      </div>
                      <div class="relative h-6 w-6" *ngIf="order.authCertified">
                        <img
                          class="absolute left-1 top-0.5 h-6 w-6"
                          src="../../../assets/img/certified.png"
                          title="Player name certified"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <app-item-details class="-mt-1 mb-1" [item]="order.item" [details]="order.details"></app-item-details>
                <div class="relative flex min-h-4 pr-12 text-xs">
                  <span class="px-1">{{ order.description }}</span>
                  <div class="absolute bottom-0 right-0 -mb-1 mt-1 flex">
                    <span>{{ formatLastUpdate(order.lastRefresh) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
<div class="absolute left-0 top-0 z-40 flex h-screen w-screen bg-gwt-back p-4" *ngIf="popup" (click)="popup = false">
  <div class="flex h-full w-full items-center justify-center bg-gwt-back">
    <div class="bg-frame flex h-48 w-[800px] p-4" (click)="stopClick($event)">
      <div class="quick mt-2 h-32 w-32">
        <img class="h-32 w-32 object-contain p-6" [src]="getImageSource(item)" />
      </div>
      <div class="flex w-[calc(100%-140px)] flex-col pl-24">
        <div class="mb-2 mt-5 w-full text-center text-2xl text-white">Contact the player in game</div>
        <textarea
          class="frame h-16 w-full p-2 text-sm font-semibold text-white"
          #area
          (focus)="area.select()"
          readonly="readonly"
          >{{ tradeMessage }}</textarea
        >
      </div>
    </div>
  </div>
</div>
<app-new-order [preselect]="item" (createOrder)="onCreateOrder($event)"></app-new-order>
